import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Header, { headerItemsLabels } from '../../Common/Header/header';
import { gridsNames } from '../../../enums/gridsNames';
import { FetchEntitiesFilters } from '../../../enums/fetchEntitiesFilters';
import { PL_DialogWrapper } from 'infrastructure/js/components/Dialog/dialog';
import ArchiveAssetsDialog from '../../Dialogs/ArchiveAssetsDialog/archiveAssetsDialog';
import MoveAssetsDialog from '../../Dialogs/MoveAssetsDialog/moveAssetsDialog';
import ShelfLifeUpdateDialog from '../../Dialogs/ShelfLifeUpdateDialog/shelfLifeUpdateDialog';
import PrintRfidTagsDialog from '../../Dialogs/PrintRfidTagsDialog/printRfidTagsDialog';
import EditAssetAttributesDialog from '../../Dialogs/EditAssetAttributesDialog/editAssetAttributesDialog';
import PrintPdfLabelsDialog from '../../Dialogs/PrintPdfLabelsDialog/printPdfLabelsDialog';
import ActiveKitsGrid from './ActiveKitsGrid/activeKitsGrid';
import { ImportAcceptFileTypes, ImportTypes } from '../../../enums/importTypes';
import { getEnumValue, enumTypes } from '../../../utils/enumHelper';
import { isAllAssetsUncured } from '../../../utils/assetsHelper';
import PermissionManager from 'infrastructure/js/utils/permissionManager';

require('./activeKitsPage.scss');

export default class ActiveKitsPage extends Component {


  getDialogConfig = () => {
    return {
      boEntityFilter: [FetchEntitiesFilters.ACTIVE],
      entitiesTypes: [getEnumValue(enumTypes.OBJECT_TYPE)('KIT')],
      preselectedAssets: this.props.sSelectedRowsData,
    };
  };

  getMoveAssetsDialogConfig = () => {
    return {
      boEntityFilter: [FetchEntitiesFilters.ACTIVE],
      entitiesTypes: [getEnumValue(enumTypes.OBJECT_TYPE)('KIT')],
      preselectedAssets: this.props.sSelectedRowsData,
    };
  };

  getUpdateShelfLifeDialogConfig = () => {
    return {
      // boEntityFilter: BO_EntityFilters.NOT_CURED,
      boEntityFilter: [FetchEntitiesFilters.ACTIVE, FetchEntitiesFilters.NOT_CURED],
      entitiesTypes: [getEnumValue(enumTypes.OBJECT_TYPE)('KIT')],
      preselectedAssets: this.props.sSelectedRowsData,
    };
  };

  getPrintPdfLabelsDialogConfig = () => {
    return {
      // boEntityFilter: BO_EntityFilters.ALL,
      boEntityFilter: [FetchEntitiesFilters.ALL],
      preselectedAssets: this.props.sSelectedRowsData,
      entitiesTypes: [
        getEnumValue(enumTypes.OBJECT_TYPE)('KIT'),
        getEnumValue(enumTypes.OBJECT_TYPE)('ROLL'),
      ],
    };
  };

  getHeaderItems() {
    let { actions, sHasRows, sSelectedRowsData } = this.props;
    let dialogConfig = this.getDialogConfig();
    let importConfig = this.getImportConfig();
    let updateShelfLifeConfig = this.getUpdateShelfLifeDialogConfig();

    let items = {
      buttons: [
        {
          id: 'clearFilters',
          label: '',
          icon: 'pl pl-filter-clear',
          action: actions.clearFilters,
          tooltip: headerItemsLabels.CLEAR_FILTERS,
        },
        {
          id: 'refresh',
          label: '',
          icon: 'pl pl-refresh',
          action: this.reloadPage,
          tooltip: headerItemsLabels.REFRESH_ALL,
        },
        ...(PermissionManager.hasEditAttributesPermissions()
          ? [
              {
                id: 'edit',
                label: headerItemsLabels.EDIT_ATTRIBUTES,
                icon: 'pl pl-edit-icon',
                counter: sSelectedRowsData.size,
                disabled: !sHasRows,
                action: actions.header.onMenuItemEditAssetAttributesClick,
                actionData: dialogConfig,
              },
            ]
          : []),
        {
          id: 'export',
          icon: 'pl pl-export-icon',
          tooltip: headerItemsLabels.EXPORT,
          disabled: !sHasRows,
          action: actions.exportActions.export,
          actionData: { gridName: gridsNames.PREDEFINED_LIST_ACTIVE_KITS },
        },
      ],

      kebab: {
        menuItems: [
          {
            id: 'moveTo',
            label: headerItemsLabels.MOVE_TO,
            action: actions.header.onMenuItemMoveToClick,
            actionData: this.getMoveAssetsDialogConfig(),
          },
          ...(PermissionManager.hasArchiveAssetsPermissions()
            ? [
                {
                  id: 'archive',
                  label: headerItemsLabels.ARCHIVE,
                  action: actions.header.onMenuItemArchiveClick,
                  actionData: dialogConfig,
                },
              ]
            : []),
          ...(PermissionManager.hasImportAssetsPermissions()
            ? [
                {
                  id: 'importKits',
                  label: headerItemsLabels.IMPORT_KITS,
                  action: actions.header.importItems,
                  disabled: PermissionManager.isWeightSupported(),
                  actionData: importConfig,
                },
              ]
            : []),
          {
            id: 'exportKitReport',
            label: headerItemsLabels.EXPORT_KIT_REPORT,
            action: actions.header.onExportKitReportClick,
            actionData: sSelectedRowsData,
            disabled: !sSelectedRowsData || sSelectedRowsData.size === 0,
          },
          {
            id: 'printLabels',
            label: headerItemsLabels.PRINT_LABEL,
            action: actions.header.onMenuItemPrintLabelClick,
            actionData: this.getPrintPdfLabelsDialogConfig(),
            disabled: !sHasRows,
          },
          {
            id: 'printRfidTags',
            label: headerItemsLabels.PRINT_RFID_TAGS,
            action: actions.header.onMenuItemPrintRfidTagsClick,
            actionData: dialogConfig,
            disabled: !sHasRows,
          },
        ],
      },
    };

    if (PermissionManager.hasUpdateShelfLifePermissions()) {
      items.kebab.menuItems.splice(1, 0, {
        id: 'upadteShelfLife',
        label: headerItemsLabels.UPDATE_SELF_LIFE,
        action: actions.header.onUpdateShelfLifeClick,
        actionData: updateShelfLifeConfig,
        disabled: sHasRows && !isAllAssetsUncured(sSelectedRowsData),
      });
    }
    return items;
  }

  getImportConfig = () => {
    let config = {
      importTypes: [ImportTypes.IMPORT_KITS],
      acceptFileTypes: [ImportAcceptFileTypes.CSV, ImportAcceptFileTypes.JSON],
      parentComponent: this.reloadPage,
      shouldIncludeLocation: true,
      showPrintLabels: true,
    };
    return config;
  };

  reloadPage = () => {
    this.props.actions.reload();
  };

  renderEditAssetAttributesDialog = () => {
    return (
      <PL_DialogWrapper
        dialogComponent={EditAssetAttributesDialog}
        show={this.props.sEditAssetAttributesData.get('show')}
        actions={this.props.actions.editAssetAttributesActions}
        sData={this.props.sEditAssetAttributesData}
        reloadParentComponent={this.reloadPage}
      />
    );
  };

  renderMoveAssetsDialog = () => {
    return (
      <PL_DialogWrapper
        dialogComponent={MoveAssetsDialog}
        show={this.props.sMoveAssetsData.get('show')}
        actions={this.props.actions.moveAssetsActions}
        sData={this.props.sMoveAssetsData}
        reloadParentComponent={this.reloadPage}
      />
    );
  };

  renderShelfLifeUpdateDialog = () => {
    return (
      <PL_DialogWrapper
        dialogComponent={ShelfLifeUpdateDialog}
        show={this.props.sShelfLifeUpdateData.get('show')}
        actions={this.props.actions.shelfLifeUpdateActions}
        sData={this.props.sShelfLifeUpdateData}
        reloadParentComponent={this.reloadPage}
      />
    );
  };

  renderArchiveAssetsDialog = () => {
    return (
      <PL_DialogWrapper
        dialogComponent={ArchiveAssetsDialog}
        show={this.props.sArchiveAssetsData.get('show')}
        sData={this.props.sArchiveAssetsData}
        actions={this.props.actions.archiveAssetsActions}
        reloadParentComponent={this.reloadPage}
      />
    );
  };

  renderPrintRfidTagsDialog = () => {
    return (
      <PL_DialogWrapper
        dialogComponent={PrintRfidTagsDialog}
        show={this.props.sPrintRfidTagsDialogData.get('show')}
        actions={{...this.props.actions.printRfidTagsActions, ...this.props.actions.fetchEntitiesActions}}
        sData={this.props.sPrintRfidTagsDialogData}
        currentAsset={this.props.assetDetails}
        reloadParentComponent={this.reloadPage}
      />
    );
  };

  renderPrintPdfLabelsDialog = () => {
    return (
      <PL_DialogWrapper
        dialogComponent={PrintPdfLabelsDialog}
        show={this.props.sPrintPdfLabelsData.get('show')}
        actions={this.props.actions.printPdfLabelsActions}
        sData={this.props.sPrintPdfLabelsData}
        reloadParentComponent={this.reloadPage}
      />
    );
  };

  render() {
    let headerItems = this.getHeaderItems();
    return (
      <div className="active-kits-page">
        <Header {...headerItems} />
        <ActiveKitsGrid
          actions={{
            ...this.props.actions.activeKitsGridActions,
            ...this.props.actions.fetchEntitiesActions,
          }}
        />
        {this.renderEditAssetAttributesDialog()}
        {this.renderMoveAssetsDialog()}
        {this.renderShelfLifeUpdateDialog()}
        {this.renderArchiveAssetsDialog()}
        {this.renderPrintRfidTagsDialog()}
        {this.renderPrintPdfLabelsDialog()}
      </div>
    );
  }
}

ActiveKitsPage.propTypes = {
  actions: PropTypes.object.isRequired,
  sActiveKitsGrid: PropTypes.object,
  sHasRows: PropTypes.bool.isRequired,
  sSelectedRowsData: PropTypes.object,
};
